import { render, staticRenderFns } from "./TeoricasAgendadasHojeModal.vue?vue&type=template&id=2cbaf1b6&scoped=true"
import script from "./TeoricasAgendadasHojeModal.vue?vue&type=script&lang=js"
export * from "./TeoricasAgendadasHojeModal.vue?vue&type=script&lang=js"
import style0 from "./TeoricasAgendadasHojeModal.vue?vue&type=style&index=0&id=2cbaf1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbaf1b6",
  null
  
)

export default component.exports